module.exports = __webpack_public_path__ + "img/Interest-Rate-Mockup.b96c013b.svg";